import { render } from "./TopSupplier.vue?vue&type=template&id=1b2ba462"
import script from "./TopSupplier.vue?vue&type=script&lang=js"
export * from "./TopSupplier.vue?vue&type=script&lang=js"

import "./TopSupplier.vue?vue&type=style&index=0&id=1b2ba462&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__